var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPresent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.64542,
    cy: 9.76555,
    rx: 9.03226,
    ry: 9.09367,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.64542 0.671875C4.65735 0.671875 0.613159 4.74357 0.613159 9.76555C0.613159 14.7875 4.65735 18.8592 9.64542 18.8592C14.6335 18.8592 18.6777 14.7875 18.6777 9.76555C18.6777 4.74357 14.6335 0.671875 9.64542 0.671875ZM14.6937 8.0279L9.00337 13.7569C8.86187 13.8994 8.67069 13.979 8.47122 13.979C8.27176 13.979 8.07983 13.8994 7.93907 13.7569L5.34004 11.1402C5.04574 10.8439 5.04574 10.365 5.34004 10.0687C5.63434 9.77237 6.11004 9.77237 6.40434 10.0687L8.47122 12.1496L13.6294 6.95636C13.9237 6.66006 14.3994 6.66006 14.6937 6.95636C14.988 7.25266 14.988 7.7316 14.6937 8.0279Z",
    fill: "#69A60C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPresent);
export default __webpack_public_path__ + "static/media/ic_present.c80c525c76777fc1c47db6ae0e69ab60.svg";
export { ForwardRef as ReactComponent };